import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { GuideSubsection } from '../common/GuideSubsection';
import { StepByStep } from '../common/StepByStep';
import { Tip } from '../common/Tip';
import { useTranslation } from '../../../i18n';

export const LlmChatSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="llm-chat" title={t('guide.sections.llmChat')}>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.llmChat.intro')}
      </Typography>

      <StepByStep
        steps={[
          t('guide.llmChat.steps.s1'),
          t('guide.llmChat.steps.s2'),
          t('guide.llmChat.steps.s3'),
          t('guide.llmChat.steps.s4'),
        ]}
      />

      <GuideSubsection id="llm-sql" title={t('guide.llmChat.sql.title')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.llmChat.sql.description')}
        </Typography>
        <Tip>{t('guide.llmChat.sql.examples')}</Tip>
      </GuideSubsection>

      <GuideSubsection id="llm-maintenance" title={t('guide.llmChat.maintenance.title')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.llmChat.maintenance.description')}
        </Typography>
        <Tip>{t('guide.llmChat.maintenance.examples')}</Tip>
      </GuideSubsection>

      <GuideSubsection id="llm-tips" title={t('guide.sections.llmChatTips')}>
        <Tip>{t('guide.llmChat.tips.rateLimit')}</Tip>
        <Tip>{t('guide.llmChat.tips.feedback')}</Tip>
        <Tip>{t('guide.llmChat.tips.privacy')}</Tip>
        <Tip>{t('guide.llmChat.tips.session')}</Tip>
      </GuideSubsection>
    </GuideSection>
  );
};
